export default "__VITE_ASSET__Bm5cO0kI__"